import { CartAddEvent } from '@theme/events';

/**
 * ChiDrops CLEANSE PDP (Resilia-Layout) — Seiten-JS.
 * ATC-Logik uebernommen aus assets/cd-vsl.js (Offer-Page): fetch auf
 * Theme.routes.cart_add_url + CartAddEvent, der Horizon-Drawer oeffnet sich
 * ueber auto_open_cart_drawer selbst, sonst manuell.
 */

/* ------------------------------------------------------------- Countdown */
function initCountdown() {
  const el = document.getElementById('cd-timer');
  if (!el) return;
  const end = Date.now() + 2 * 3600 * 1000;
  const pad = (n) => (n < 10 ? '0' : '') + n;
  setInterval(() => {
    const d = Math.max(0, end - Date.now());
    const h = Math.floor(d / 3600000);
    const m = Math.floor((d % 3600000) / 60000);
    const s = Math.floor((d % 60000) / 1000);
    const L = document.documentElement.lang.startsWith('en')
      ? ['Hrs', 'Min', 'Sec']
      : ['Std', 'Min', 'Sek'];
    el.textContent = `${pad(h)} ${L[0]} : ${pad(m)} ${L[1]} : ${pad(s)} ${L[2]}`;
  }, 1000);
}

/* ------------------------------------------- Galerie: Swipe + Thumb-Sync */
function initGallery() {
  const track = document.getElementById('g-track');
  const thumbs = [...document.querySelectorAll('#g-thumbs img')];
  if (!track || !thumbs.length) return;
  const slideW = () => track.clientWidth || 1;
  thumbs.forEach((t, i) => {
    t.addEventListener('click', () => {
      track.scrollTo({ left: i * slideW(), behavior: 'smooth' });
    });
  });
  let raf = 0;
  track.addEventListener(
    'scroll',
    () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(track.scrollLeft / slideW());
        thumbs.forEach((t, j) => t.classList.toggle('active', j === i));
      });
    },
    { passive: true }
  );
}

/* --------------------------------- Paketwahl: Preis + ATC-Ziel umschalten */
window.selPack = function selPack(el) {
  const box = el.parentElement;
  [...box.children].forEach((p) => {
    if (p.classList && p.classList.contains('pack')) p.classList.remove('selected');
  });
  el.classList.add('selected');
  const price = el.getAttribute('data-price') + '\u00a0\u20ac';
  const variantId = el.getAttribute('data-variant');
  const compare = el.getAttribute('data-compare');
  const discount = el.getAttribute('data-discount') || '';
  const atcp = document.getElementById('atc-price');
  if (atcp) atcp.textContent = price;
  document.querySelectorAll('.atc-price2').forEach((n) => (n.textContent = price));
  const atcc = document.getElementById('atc-compare');
  if (atcc && compare) atcc.textContent = compare + '\u00a0\u20ac';
  if (variantId) {
    const cartUrl = (window.Theme && Theme.routes.cart_url) || '/cart';
    const suffix = discount ? `?discount=${encodeURIComponent(discount)}` : '';
    document.querySelectorAll('a[data-cd-atc]').forEach((a) => {
      a.dataset.cdAtc = variantId;
      a.dataset.cdDiscount = discount;
      a.setAttribute('href', `${cartUrl}/${variantId}:1${suffix}`);
    });
  }
};

/* ----------------------------------- Rabattcode des Pakets an den Warenkorb
   /cart/update.js haengt den Code direkt an den Warenkorb, /discount/<CODE>
   setzt dagegen nur einen Cookie. Der Status ist immer 200, auch bei einem
   ungueltigen Code: Erfolg erkennt man nur daran, ob der Code danach in
   items[].discounts[] steht. Immer nur den Code der tatsaechlich gewaehlten
   Stufe schicken, ein nicht anwendbarer Code entfernt den zuvor gesetzten. */
async function applyPackDiscount(code) {
  if (!code) return;
  try {
    const cart = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ discount: code }),
    }).then((r) => r.json());

    const applied = (cart.items || []).some((item) =>
      (item.discounts || []).some((d) => (d.title || '').toUpperCase() === code.toUpperCase())
    );
    if (!applied) console.warn('[cd-pdp] Rabattcode nicht angewendet:', code);
  } catch (error) {
    console.error('[cd-pdp] Rabattcode fehlgeschlagen:', code, error);
  }
}

/* ------------------------- Sticky-Bar: nicht neben den Angebots-Sektionen */
function initStickyBar() {
  const bar = document.querySelector('.cd-pdp .stickybar');
  const a = document.querySelector('.cd-pdp .buy-grid');
  const o = document.querySelector('.cd-pdp .offerbox');
  if (!bar || !a) return;
  const inView = (el) => {
    if (!el) return false;
    const r = el.getBoundingClientRect();
    return r.bottom > 0 && r.top < window.innerHeight;
  };
  const upd = () => bar.classList.toggle('show', !(inView(a) || inView(o)));
  window.addEventListener('scroll', upd, { passive: true });
  window.addEventListener('resize', upd);
  upd();
}

/* ------------------------------------------------------------ Add to cart */
/** @returns {string} kommaseparierte Section-IDs, die der Server mitrendern soll */
function cartSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => (el instanceof HTMLElement ? el.dataset.sectionId : null))
    .filter(Boolean)
    .join(',');
}

async function addToCart(link) {
  const variantId = Number(link.dataset.cdAtc);
  if (!variantId) return;

  link.setAttribute('aria-busy', 'true');

  try {
    const response = await fetch(Theme.routes.cart_add_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: cartSectionIds(),
      }),
    }).then((r) => r.json());

    if (response.status) {
      console.error('[cd-pdp] Add to cart fehlgeschlagen:', response.description || response.message);
      window.location.href = link.getAttribute('href');
      return;
    }

    await applyPackDiscount(link.dataset.cdDiscount);

    const cart = await fetch(`${Theme.routes.cart_url}.js`)
      .then((r) => r.json())
      .catch(() => undefined);

    document.dispatchEvent(
      new CartAddEvent(cart, link.id, {
        source: 'cd-pdp-page',
        itemCount: 1,
        variantId: String(variantId),
        sections: response.sections,
      })
    );

    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && !drawer.querySelector('dialog')?.open) {
      customElements.whenDefined('cart-drawer-component').then(() => drawer.open?.());
    }
  } catch (error) {
    console.error('[cd-pdp] Add to cart fehlgeschlagen:', error);
    window.location.href = link.getAttribute('href');
  } finally {
    link.removeAttribute('aria-busy');
  }
}

function initAddToCart() {
  document.querySelectorAll('a[data-cd-atc]').forEach((link) => {
    link.addEventListener('click', (event) => {
      event.preventDefault();
      addToCart(link);
    });
  });
}



/* ------------------------------------------------------------------ Start */
function init() {
  initCountdown();
  initGallery();
  initStickyBar();
  initAddToCart();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
